// Small masking helpers used across the onboarding screens.
export const maskMobile = (mobile: string): string => {
  const digits = mobile.replace(/\D/g, '').slice(-10);
  return `+91 ${digits.slice(0, 2)}xxx xx${digits.slice(7)}`;
};

export const maskEmail = (email: string): string => {
  const [local, domain] = email.split('@');
  if (!domain) return email;
  return `${local.slice(0, 2)}****@${domain}`;
};
